import { useCallback, useState } from "react";

export type ThemePref = "system" | "light" | "dark";
const KEY = "wp-theme";

function read(): ThemePref {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

/** Light / dark / follow-the-OS preference, applied as <html data-theme> (index.html restores it before paint). */
export function useTheme() {
  const [theme, setThemeState] = useState<ThemePref>(read);
  const setTheme = useCallback((t: ThemePref) => {
    setThemeState(t);
    if (t === "system") delete document.documentElement.dataset.theme;
    else document.documentElement.dataset.theme = t;
    try {
      if (t === "system") localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, t);
    } catch { /* private mode: the choice lasts for this tab only */ }
  }, []);
  return { theme, setTheme };
}
